var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ToolButton',{attrs:{"Editor":_vm.Editor,"KnownIcon":"CodeView"},on:{"ToolClick":function($event){return _vm.ToggleCodeBlock()}}})}
var staticRenderFns = []

export { render, staticRenderFns }